import { Participant } from "./chatsSlice"
import { Profile } from "./profilesSlice"
import { RootState } from "./store"
import { findProfile } from "./profilesSliceSelectors"
import { resolveDriverJidForChat } from "../lib/resolveDriverForChat"

/**
 * Selector that returns the effective driver (as Profile | Participant | undefined)
 * for a given chat JID.
 *
 * Who the driver is comes from `resolveDriverJidForChat`; this only turns that
 * JID into someone displayable, preferring the profile and falling back to the
 * room participant while the profile is still loading. A chat with an empty
 * seat has no driver to show - the participant list still holds whoever used
 * to drive it, so it must not be consulted.
 */
export const selectEffectiveDriverForChat = (chatJid: string | undefined) => {
  return (state: RootState): Profile | Participant | undefined => {
    if (!chatJid) return undefined

    const accountChat =
      state.accountChats[chatJid] ?? state.userChats?.[chatJid]
    const driverJid = resolveDriverJidForChat(accountChat, chatJid)

    if (!driverJid) return undefined

    const profile = findProfile(driverJid)(state)
    if (profile) return profile

    // Profile not yet loaded — fall back to participant for immediate display
    return state.chats
      .find((c) => c.jid === chatJid)
      ?.participants.find((p) => p.role === "driver")
  }
}
